export default __webpack_public_path__ + "static/media/hydro-4-1point5-768x510.1ceee30d.jpg";